import { render, staticRenderFns } from "./CampusPage.vue?vue&type=template&id=239abfae&scoped=true&"
import script from "./CampusPage.vue?vue&type=script&lang=js&"
export * from "./CampusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239abfae",
  null
  
)

export default component.exports